window.addEventListener('load', function() {
  $('[data-modal-open]').on('click', function(e) {
    e.preventDefault();
    var target = $(this).attr('data-modal-open');
    $('[data-modal="' + target + '"]').addClass('active');
    $('.aw-about-services__modal-wrap').addClass('active');
  });

  $('.modal-close, .aw-about-services__modal-wrap').on('click', function(e) {
    if ($(e.target).hasClass('aw-about-services__modal-wrap') || $(e.target).hasClass('modal-close')) {
      $('[data-modal]').removeClass('active');
      $('.aw-about-services__modal-wrap').scrollTop(0).removeClass('active');
    }
  });
});

window.addEventListener('load', function() {
  $('.aw-about-data__tab a').on('click', function(e) {
    e.preventDefault();

    const tabValue = $(this).data('tab');

    $('.aw-about-data__tab a').removeClass('active');
    $(this).addClass('active');

    $('.aw-about-data__content').removeClass('active');
    $(`.aw-about-data__content[data-content="${tabValue}"]`).addClass('active');
  });
});
